/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StackSpecificFrame } from './StackSpecificFrame';
import {
    StackSpecificFrameFromJSON,
    StackSpecificFrameFromJSONTyped,
    StackSpecificFrameToJSON,
} from './StackSpecificFrame';

/**
 * 
 * @export
 * @interface StackCode
 */
export interface StackCode {
    /**
     * 
     * @type {string}
     * @memberof StackCode
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof StackCode
     */
    filename?: string;
    /**
     * 
     * @type {Array<StackSpecificFrame>}
     * @memberof StackCode
     */
    frames: Array<StackSpecificFrame>;
}

/**
 * Check if a given object implements the StackCode interface.
 */
export function instanceOfStackCode(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "frames" in value;

    return isInstance;
}

export function StackCodeFromJSON(json: any): StackCode {
    return StackCodeFromJSONTyped(json, false);
}

export function StackCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StackCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
        'frames': ((json['frames'] as Array<any>).map(StackSpecificFrameFromJSON)),
    };
}

export function StackCodeToJSON(value?: StackCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'filename': value.filename,
        'frames': ((value.frames as Array<any>).map(StackSpecificFrameToJSON)),
    };
}

